import React, { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, TextField, Typography } from '@mui/material';
import api from '../api';

const fehlerText = (e: any, standard: string) => e?.response?.data?.fehler || standard;

// Eigenes Passwort ändern (angemeldet)
export function PasswortAendern({ onClose }: { onClose: () => void }) {
  const [alt, setAlt] = useState('');
  const [neu, setNeu] = useState('');
  const [wdh, setWdh] = useState('');
  const [fehler, setFehler] = useState('');
  const [fertig, setFertig] = useState(false);
  const [arbeitet, setArbeitet] = useState(false);

  const speichern = async (e: React.FormEvent) => {
    e.preventDefault();
    if (neu !== wdh) { setFehler('Die beiden neuen Passwörter stimmen nicht überein.'); return; }
    setArbeitet(true);
    setFehler('');
    try {
      await api.post('/auth/passwort', { altesPasswort: alt, neuesPasswort: neu });
      setFertig(true);
    } catch (err) {
      setFehler(fehlerText(err, 'Das Passwort konnte nicht geändert werden.'));
    } finally { setArbeitet(false); }
  };

  return (
    <Dialog open onClose={arbeitet ? undefined : onClose} maxWidth="xs" fullWidth>
      <form onSubmit={speichern}>
        <DialogTitle>Passwort ändern</DialogTitle>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: '8px !important' }}>
          {fertig ? <Alert severity="success">Ihr Passwort wurde geändert.</Alert> : (
            <>
              {fehler && <Alert severity="error">{fehler}</Alert>}
              <TextField label="Bisheriges Passwort" type="password" autoComplete="current-password" required value={alt} onChange={e => setAlt(e.target.value)} />
              <TextField label="Neues Passwort (mind. 8 Zeichen)" type="password" autoComplete="new-password" required value={neu}
                onChange={e => setNeu(e.target.value)} inputProps={{ minLength: 8, maxLength: 200 }} />
              <TextField label="Neues Passwort wiederholen" type="password" autoComplete="new-password" required value={wdh} onChange={e => setWdh(e.target.value)} />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={arbeitet}>{fertig ? 'Schließen' : 'Abbrechen'}</Button>
          {!fertig && <Button type="submit" variant="contained" disabled={arbeitet}>Ändern</Button>}
        </DialogActions>
      </form>
    </Dialog>
  );
}

// Neues Passwort über den Link aus der E-Mail festlegen (?reset=…)
export function PasswortSetzen({ token, onFertig }: { token: string; onFertig: () => void }) {
  const [neu, setNeu] = useState('');
  const [wdh, setWdh] = useState('');
  const [fehler, setFehler] = useState('');
  const [fertig, setFertig] = useState(false);
  const [arbeitet, setArbeitet] = useState(false);

  const speichern = async (e: React.FormEvent) => {
    e.preventDefault();
    if (neu !== wdh) { setFehler('Die beiden Passwörter stimmen nicht überein.'); return; }
    setArbeitet(true);
    setFehler('');
    try {
      await api.post('/auth/passwort-zuruecksetzen', { token, passwort: neu });
      setFertig(true);
    } catch (err) {
      setFehler(fehlerText(err, 'Das Passwort konnte nicht gespeichert werden.'));
    } finally { setArbeitet(false); }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="#f5f5f5" px={2}>
      <Paper component="form" onSubmit={speichern} elevation={3} sx={{ p: 4, width: '100%', maxWidth: 380, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h5" fontWeight="bold" textAlign="center">Passwort festlegen</Typography>
        {fertig ? (
          <>
            <Alert severity="success">Ihr Passwort ist gespeichert. Sie können sich jetzt anmelden.</Alert>
            <Button variant="contained" onClick={onFertig}>Zur Anmeldung</Button>
          </>
        ) : (
          <>
            {fehler && <Alert severity="error">{fehler}</Alert>}
            <TextField label="Neues Passwort (mind. 8 Zeichen)" type="password" autoComplete="new-password" required autoFocus value={neu}
              onChange={e => setNeu(e.target.value)} inputProps={{ minLength: 8, maxLength: 200 }} />
            <TextField label="Passwort wiederholen" type="password" autoComplete="new-password" required value={wdh} onChange={e => setWdh(e.target.value)} />
            <Button type="submit" variant="contained" size="large" disabled={arbeitet}>Speichern</Button>
            <Button size="small" onClick={onFertig}>Zur Anmeldung</Button>
          </>
        )}
      </Paper>
    </Box>
  );
}
